import React from "react";

function Option({
  option,
  index,
  setAnswered,
  answered,
  questions,
  handleSetUserPoints,
}) {
  const isCorrect = questions.correctOption === index;
  const hasAnswered = answered !== null;

  const handleAnswer = () => {
    if (answered !== null) {
      return;
    }
    setAnswered(index);
    if (isCorrect) {
      handleSetUserPoints(questions.points);
    }
  };

  return (
    <button
      onClick={handleAnswer}
      className={`btn-option  ${index === answered ? "answer" : ""} 
        ${
          hasAnswered
            ? index === questions.correctOption
              ? "correct"
              : "wrong"
            : ""
        }`}
      key={option}
      disabled={hasAnswered}
    >
      {option}
    </button>
  );
}

export default Option;
